<template>
    <div :class="['rounded-large p-1 shadow-lg transition duration-500  hover:shadow-xl', theme.body.backgroundColor]">
      <svg
        @click="isListDisplayed = true"
        :class="[
          'fill-current inline-block h-8 w-8',
          isListDisplayed == false
            ? 'text-gray-600'
            : 'text-' + theme.header.selectedItemColor,
        ]"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 10h16M4 14h16M4 18h16"
        />
      </svg>

      <svg
        @click="isListDisplayed = false"
        :class="[
          'fill-current inline-block h-8 w-8',
          '',
          isListDisplayed == true
            ? 'text-gray-600'
            : 'text-' + theme.header.selectedItemColor,
        ]"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
        />
      </svg>

      <!-- <svg
      :class="['fill-current inline-block h-8 w-8 text-gray-600']"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        class="heroicon-ui"
        d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
        clip-rule="evenodd"
      />
    </svg> -->
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    isListDisplayed: {
      get() {
        return this.$store.getters["isListDisplayed"];
      },
      set(value) {
        this.$store.commit("updateIsListDisplayed", value);
      },
    },
    ...mapGetters(["selectedMenuCategory", "theme"]),
  },
};
</script>